/**
 * IRINI storefront helpers (keep separate from Prestige theme.js).
 *
 * Ring size guide: Prestige opens <x-modal> via .show() / aria-controls.
 * Product descriptions cannot hardcode dynamic modal IDs, so we use a stable
 * id="ring-size-guide-modal" and open it the same way as the native trigger.
 */
(function () {
  var MODAL_ID = 'ring-size-guide-modal';

  function isRingSizeGuideLink(anchor) {
    if (!anchor || anchor.tagName !== 'A') return false;
    if (anchor.classList.contains('js-ring-size-guide-link')) return true;
    if (anchor.hasAttribute('data-open-ring-size-guide')) return true;

    var href = anchor.getAttribute('href') || '';
    return (
      href === '#ring-size-guide' ||
      href === '#ring-size-guide-modal' ||
      href.slice(-16) === '#ring-size-guide' ||
      href.slice(-22) === '#ring-size-guide-modal'
    );
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function openModal(modal) {
    if (!modal) return;

    // Prefer Prestige Modal API once the custom element is upgraded.
    if (typeof modal.show === 'function') {
      modal.show();
      return;
    }

    modal.setAttribute('open', '');
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.nodeType !== 1) {
        target = target.parentElement;
      }

      var link = target && target.closest ? target.closest('a') : null;
      if (!link || !isRingSizeGuideLink(link)) return;

      // Stop hash jump + avoid Prestige also toggling if aria-controls was added by the RTE.
      event.preventDefault();
      event.stopPropagation();

      var modal = getModal();
      if (!modal) return;

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('x-modal').then(function () {
          openModal(getModal());
        });
      } else {
        openModal(modal);
      }
    },
    true
  );
})();
